import Vue from 'vue'
import { NetworkstatsState } from './networkstats.state'
import { firestore } from 'firebase/app'
import { UserNetworkStats } from '@/types/networkstats'

export const mutations = {
  updateUserStats (state: NetworkstatsState, snap: firestore.DocumentSnapshot) {
    const userId = snap.id
    const snapData  = (snap.data() || {}) as UserNetworkStats
    const userNetworkStats: UserNetworkStats =  {
      download: snapData.download,
      upload: snapData.upload,
      encoder: snapData.encoder,
      team_id: snapData.team_id || ''
    }

    Vue.set(state.userStats, userId, userNetworkStats)
  }
} as const
